import React from 'react';

import { useEffect, useState, useRef } from 'react';
import '../../../../src/assets/Styles/MapControlDispatchCSS/MapControlDispatch.css'

const getDateTimeObjectFromTime = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    return new Date(0, 0, 0, hours, minutes);
}

const MapInfoSummary = ({ stops = [], state = {}, clusterTableData}) => {

    const [showPreviousInfo, setShowPreviousInfo] = useState(false);

    useEffect(() => {
        setShowPreviousInfo(false);
    }, [])

    useEffect(() => {

        if(clusterTableData != null){
            setShowPreviousInfo(true);
        }

    }, [clusterTableData])

    /// Section For Previous Summary ///
    let estMilesTot_Prev = 0;
    let estTimeTot_Prev = 0;
    let tripCount_Prev = 0;
    //let passCount_Prev = [];
    let passCount_Prev = 0;

    if(clusterTableData != undefined && clusterTableData?.length > 0){
        for(let i = 0; i < clusterTableData?.length; i++)
        {
            if(!clusterTableData[i].Type.toUpperCase().includes("IDLE")){
                estMilesTot_Prev+= parseFloat(clusterTableData[i].EstDistFromPrev);
                estTimeTot_Prev+= parseFloat(clusterTableData[i].EstTimeFromPrev);
            }
            
            if(clusterTableData[i].Type.toUpperCase() === "PU" || clusterTableData[i].Type.toUpperCase() === "DO")
            {
                tripCount_Prev+=1;

                if(clusterTableData[i].Type.toUpperCase() === "PU"){
                    passCount_Prev += clusterTableData[i].iTotalPassengerCount;
                }
                //passCount_Prev.push(clusterTableData[i].PUPerson);
            }
        }
        //passCount_Prev = [...new Set(passCount_Prev)];
        tripCount_Prev = Math.ceil(tripCount_Prev / 2);
    
    }
   


    const tripFlash_ForPrev = useValueFlash(tripCount_Prev);
    const milesFlash_ForPrev = useValueFlash(estMilesTot_Prev);
    const estTimeTotFlash_ForPrev = useValueFlash(estTimeTot_Prev);
    const passCountFlash_ForPrev = useValueFlash(passCount_Prev);
    ////////////////////////////////////




    let estMilesTot = 0;
    let estTimeTot = 0;
    let tripCount = 0;
    let passCount = [];
    let passCountValue = 0;
    let isSummaryEvaluated = false;
    let differenceInMinutes = null;
    let routeSummary = '';
    let isSchDateGreater = false;

    for (let i = 0; i < stops.length; i++) {
        estMilesTot += parseFloat(stops[i].EstDistFromPrev || 0);
        estTimeTot += parseFloat(stops[i].EstTimeFromPrev || 0);

        const type = stops[i].Type?.toUpperCase();
        if (type === 'PU' || type === 'DO') {
            if (!stops[i].bPerformed && !isSummaryEvaluated) {
                const schDate = getDateTimeObjectFromTime(stops[i].SchTime);
                const forecastedDate = getDateTimeObjectFromTime(stops[i].ForcastedTime);
                isSchDateGreater = schDate > forecastedDate;
                const differenceInMs = schDate - forecastedDate;
                differenceInMinutes = Math.floor(differenceInMs / (1000 * 60));
                isSummaryEvaluated = true;
            }
            tripCount += 1;
            if(type === "PU"){
                passCountValue += stops[i].iTotalPassengerCount;
            }
            //passCount.push(stops[i].PUPerson);
        }
    }

    if (differenceInMinutes !== null) {
        const absDifference = Math.abs(differenceInMinutes);
        if (absDifference <= 5 || differenceInMinutes === 0) {
            routeSummary = '| On Time';
        } else if (isSchDateGreater && absDifference > 5) {
            routeSummary = `| Early: ${absDifference} minutes`;
        } else if (!isSchDateGreater && absDifference > 5) {
            routeSummary = `| Late: ${absDifference} minutes`;
        }
    }

    //passCount = [...new Set(passCount)];
    const displayTripCount = Math.ceil(tripCount / 2);

    const displayText = `Original: Trips: ${displayTripCount} | Est. Dist: ${estMilesTot.toFixed(2)} mi | Est. Time: ${parseInt(estTimeTot)} mins | Pax Count: ${passCountValue} ${routeSummary}`;

    // const displayText = content.length === 0
    //     ? `Original: Trips: ${displayTripCount} | Est. Dist: ${estMilesTot.toFixed(2)} mi | Est. Time: ${parseInt(estTimeTot)} mins | Pax Count: ${passCount.length} ${routeSummary}`
    //     : `Original: Trips: ${content[0]} | Est. Dist: ${content[1].toFixed(2)} mi | Est. Time: ${parseInt(content[2])} mins | Pax Count: ${content[3]} ${routeSummary}`;

    const tripFlash = useValueFlash(displayTripCount);
    const milesFlash = useValueFlash(estMilesTot);
    const estTimeTotFlash = useValueFlash(estTimeTot);
    const passCountFlash = useValueFlash(passCountValue);
    const routeSummaryFlash = useValueFlash(routeSummary);

    return (
        <div
           // id={`${state.GridName}_clusterInfoDiv`}
            //className="shadow-sm border-dark user-select-none fw-bold p-1 mt-3 mapInfoTextDiv text-start"
            style={{
                color: 'white',
                cursor: 'default',
                fontFamily: state.commonStyles?.fontFamily,
                padding: state.commonStyles?.padding,
                textAlign: state.commonStyles?.textAlign,
               // backgroundColor: '#627d91',
                overflow: 'hidden',
                fontSize: "14px",
                marginTop: "0px !important",
                textAlign: "center",
                padding: "5px",
                width: "100%"
            }}
        >
            {/** Info Div Current */}
            <div>
                <label
                    style={{
                        display: 'inline-flex',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textWrap: 'auto',
                        width: '100%',
                        justifyContent: "space-around",
                        alignItems: "center",
                        color: "greenyellow"
                    }}
                >
                    {/* {displayText} */}
                    <span style={{  padding: '2px 6px'}} >
                        Original:
                    </span>
                    <span style={{  padding: '2px 6px'}} className={tripFlash ? "green-flash" : ""}>
                        Trips: {displayTripCount}
                    </span>
                    <span style={{  padding: '2px 6px' }} className={milesFlash ? "green-flash" : ""}>
                        Est. Dist: {estMilesTot.toFixed(2)} mi
                    </span>
                    <span style={{ padding: '2px 6px' }} className={estTimeTotFlash ? "green-flash" : ""}>
                        Est. Time: {parseInt(estTimeTot)} mins
                    </span>
                    <span style={{  padding: '2px 6px' }} className={passCountFlash ? "green-flash" : ""}>
                        Pax Count: {passCountValue}
                    </span>
                    <span style={{  padding: '2px 6px' }} className={routeSummaryFlash ? "green-flash" : ""}>
                        {routeSummary.replace('|', '').trim()}
                    </span>
                </label>
            </div>
            {/** Info Div Current */}

            {/** Info Div Previous */}
            {showPreviousInfo &&
                <div>
                    <label
                        style={{
                            display: 'inline-flex',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textWrap: 'auto',
                            width: '100%',
                            justifyContent: "space-around",
                            alignItems: "center",
                            color: "white"
                        }}
                    >
                        
                        <span style={{  padding: '2px 6px'}} >
                            New:
                        </span>
                        <span style={{  padding: '2px 6px'}} className={tripFlash_ForPrev  ? "green-flash" : ""}>
                            Trips: {tripCount_Prev}
                        </span>
                        <span style={{  padding: '2px 6px' }} className={milesFlash_ForPrev  ? "green-flash" : ""}>
                            Est. Dist: {estMilesTot_Prev.toFixed(2)} mi
                        </span>
                        <span style={{ padding: '2px 6px' }} className={estTimeTotFlash_ForPrev  ? "green-flash" : ""}>
                            Est. Time: {parseInt(estTimeTot_Prev)} mins
                        </span>
                        <span style={{  padding: '2px 6px' }} className={passCountFlash_ForPrev  ? "green-flash" : ""}>
                            Pax Count: {passCount_Prev}
                        </span>
                        <span style={{  padding: '2px 6px' }} className={routeSummaryFlash ? "green-flash" : ""}>
                        
                        </span>
                    </label>
                </div>
            }
            {/** Info Div Previous */}
        </div>
    );
};

function useValueFlash(value) {
    const [flash, setFlash] = useState(false);
    const prev = useRef(value);
  
    useEffect(() => {
      if (prev.current !== value) {
        setFlash(true);
        prev.current = value;
        setTimeout(() => setFlash(false), 2000);
      }
    }, [value]);
  
    return flash;
  }

export default MapInfoSummary;
